"use client";

import { useRef } from "react";
import StoreBox from "../store/store-box";
import ProfilePage from "./profile-page";

const ProfileContainer = (props) => {
  const {
    storePath,
    cart,
    fullUrlPath,
    organisation,
    accessPointId,
    loginSuccessHandler,
  } = props;

  const scrollRef = useRef(null);

  return (
    <StoreBox
      {...props}
      handleLocationChange={() => {}}
      bodyClassName="profile-target"
    >
      <div className="profile-container" ref={scrollRef}>
        <ProfilePage
          storePath={storePath}
          cart={cart}
          fullUrlPath={fullUrlPath}
          organisation={organisation}
          accessPointId={accessPointId}
          parentScrollRef={scrollRef}
          handleLoginSuccess={loginSuccessHandler}
        />
      </div>
    </StoreBox>
  );
};

export default ProfileContainer;
